import { Component, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SkuRankingHelper } from './sku-ranking-helper';
import { SalesDateTagService } from '../../elements/sales-date-filter-tag/sales-date-filter-tag.service';
import { authorize } from 'src/app/helpers/AuthorizePage';
@Component({
  selector: 'app-sku-ranking',
  templateUrl: './sku-ranking.component.html',
  styleUrls: ['./sku-ranking.component.scss']
})

export class SkuRankingComponent implements OnInit, OnDestroy {
  private salesDateSubscription: Subscription;
  private userGroupName: string;
  public lstAllOptionsBottlerSale: any;
  public lstAllOptionsCategoryFilter: any;
  public lstAllOptionsMarkerBrandFilter: any;
  public lstAllOptionsPackageFilter: any;
  public readyToLoadData: boolean = false;
  public selectedDateType: string = '';
  public selectedSalesDate: string[] = [];
  private loadingSubscription: Subscription;
  public isLoading: boolean = false;
  constructor(
    private router: Router,
    private http: HttpClient,
    private salesDateTagService: SalesDateTagService,
  ) { }

  ngOnInit() {
    if (!authorize()) {
      this.router.navigateByUrl('unauthorized');
    } else {
      this.readyToLoadData = false;
      this.selectedDateType = '';
      this.selectedSalesDate = [];
      this.loadingSubscription = SkuRankingHelper.isLoading().subscribe((loading: boolean) => {
        this.isLoading = loading;
      });
      this.salesDateSubscription = this.salesDateTagService.getSkuRankingSalesDate().subscribe((date: string[]) => {
        if (date && date.length > 0) {
          SkuRankingHelper.getIntageskurankingsalesfilter(this.http, date[0], this.userGroupName).then((data) => {
            this.lstAllOptionsBottlerSale = data?.FiltersBottlerSale || [];
          });

          SkuRankingHelper.getIntageskurankingAllfilterInit(this.http, date[0], this.userGroupName).then((data) => {
            this.lstAllOptionsCategoryFilter = data?.FiltersIntageCategory || [];
            this.lstAllOptionsMarkerBrandFilter = data?.FiltersIntageMakerBrand || [];
            this.lstAllOptionsPackageFilter = data?.FiltersIntagePackage || [];
          });

          this.readyToLoadData = true;
        }
      })
    };
  }

  ngOnDestroy() {
    this.loadingSubscription?.unsubscribe();
    this.salesDateSubscription?.unsubscribe();
  }

  public onDateTypeSaveItemsChange = (e: any) => {
    const { selectedDateType, selectedSalesDate } = e;

    if (selectedDateType && selectedSalesDate && selectedSalesDate.length > 0) {
      this.selectedDateType = selectedDateType;
      this.selectedSalesDate = selectedSalesDate;
      this.readyToLoadData = true;
    }
  }

}
